import { InfoMailtipCustomText } from '../strings.locstring.json';
import loc, { formatToArray } from 'owa-localize';
import * as React from 'react';

import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

export interface RecipientMailtipMessageRowProps {
    recipient: EmailAddressWrapper;
    recipientMessage: JSX.Element;
    messageTemplate?: string;
}

const RecipientMailtipMessageRow = ({
    recipient,
    recipientMessage,
    messageTemplate = loc(InfoMailtipCustomText),
}: RecipientMailtipMessageRowProps) => {
    const emailAddress: string = recipient.EmailAddress;

    return (
        <>
            {formatToArray(
                messageTemplate,
                <span key={emailAddress}>{recipient.Name}</span>,
                <span key={`${emailAddress}-message`}>{recipientMessage}</span>
            )}
        </>
    );
};

export default RecipientMailtipMessageRow;
